import { useRef } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { SVGIcon } from "~/components"
import { captureEvent } from "~/modules/analytics/capture"
import { useClickOutside, useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  position: absolute;
  // There should be a very slight gap above the button below this menu
  bottom: calc(100% + 4px);
  width: 100%;
`

const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  width: 194px;

  box-shadow: ${(props) => props.theme.shadow.elevation3};
`

const MenuItem = styled.li`
  width: 100%;
  margin: 0;
  padding: 0;
`

const MenuItemAnchor = styled(Link)`
  background: white;
  width: 100%;

  padding: 14px 16px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  gap: 8px;

  cursor: pointer;

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  color: ${(props) => props.theme.colors.gray50};
  fill: ${(props) => props.theme.colors.gray50};

  &:hover {
    background: ${(props) => props.theme.colors.primary99};
    color: ${(props) => props.theme.colors.primary10};
    fill: ${(props) => props.theme.colors.primary10};
  }

  &:active,
  &:focus {
    color: ${(props) => props.theme.colors.primary50};
    fill: ${(props) => props.theme.colors.primary50};
  }
`

export interface DashboardCreateWorksheetMenuProps {
  onClose: () => void
}

const DashboardCreateWorksheetMenu: React.FC<
  DashboardCreateWorksheetMenuProps
> = ({ onClose }) => {
  const ref = useRef<HTMLDivElement>(null)

  const translations = useTranslate({
    mathematics: "common.mathematics",
    norwegian: "common.norwegian",
    english: "common.english",
  })

  useClickOutside(ref, () => onClose())

  return (
    <Layout ref={ref}>
      <Menu>
        <MenuItem>
          <MenuItemAnchor
            to="/generator/mathematics"
            onClick={() => {
              captureEvent("open_new_worksheet", {
                subject: "mathematics",
                source: "dashboard",
              })
            }}
          >
            <SVGIcon icon="Math" />
            {translations.mathematics}
          </MenuItemAnchor>
        </MenuItem>
        <MenuItem>
          <MenuItemAnchor
            to="/generator/norwegian"
            onClick={() => {
              captureEvent("open_new_worksheet", {
                subject: "norwegian",
                source: "dashboard",
              })
            }}
          >
            <SVGIcon icon="Books" />
            {translations.norwegian}
          </MenuItemAnchor>
        </MenuItem>
        <MenuItem>
          <MenuItemAnchor
            to="/generator/english"
            onClick={() => {
              captureEvent("open_new_worksheet", {
                subject: "english",
                source: "dashboard",
              })
            }}
          >
            <SVGIcon icon="Globe" />
            {translations.english}
          </MenuItemAnchor>
        </MenuItem>
      </Menu>
    </Layout>
  )
}

export default DashboardCreateWorksheetMenu
